import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Providers from "Providers";
import { TranslationProvider } from "TranslationContext";

// Sentry.init({
//   dsn: "https://7205e82d26f8c433c01ccdabcd8fac5c@o4508724831256576.ingest.de.sentry.io/4508724840497232",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  // <ErrorBoundary>
  <Providers>
    {/* <Sentry.ErrorBoundary fallback={<FallbackUI />}> */}
    <TranslationProvider>
      <App />
    </TranslationProvider>
    {/* </Sentry.ErrorBoundary> */}
  </Providers>
  //  </React.StrictMode>
  // </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
